import { ProjectDetailsResponse } from '@/types/service-response'

export class ProjectDetail {
  public constructor (
    readonly ID: number,
    readonly IDMarker: string,
    readonly Vorgang: string,
    readonly Projekt: number,
    readonly Zeile: number,
    readonly Art: number,
    readonly Seitenumbruch: boolean,
    readonly Lagerung: string,
    readonly DisplayText: string,
    readonly Version: string,
    readonly Menge: string, //decimal
    readonly MengeErfasst: string, //decimal
    readonly Einheit: number,
    readonly Preis: string, //decimal
    readonly Waehrung: number,
    readonly Rabatt: number,
    readonly Steuer: number,
    readonly Preisherkunft: number,
    readonly Netto: boolean,
    readonly Gestaffelt: boolean,
    readonly Assortiert: boolean,
    readonly TextArt: number,
    readonly Text: string,
    readonly TextRTF: string,
    readonly KLText: string,
    readonly KLTextRTF: string,
    readonly Kommission: number,
    readonly KommissionsNummer: string,
    readonly KommissionsBezeichnung: string,
    readonly KommissionArtBezeichnung: string,
    readonly Ertrag: number,
    readonly Aufwand: number,
    readonly Kostenstelle: number,
    readonly Kostentraeger: number,
    readonly Debitoren: number,
    readonly Kreditoren: number,
    readonly Gesperrt: boolean,
    readonly GesperrtVon: number,
    readonly GesperrtVonNameK: string,
    readonly Prozessart: number,
    readonly ReferenzTermin: string,
    readonly Summenreferenz: string,
    readonly BruttoInklusive: string, //decimal
    readonly SteuerBetrag: string, //decimal
    readonly RabattBetrag: number, //decimal
    readonly ProjektRabatt: number, //decimal
    readonly NettoExklusive: string, //decimal
    readonly NettoExklusiveInland: number, //decimal
    readonly SteuerBetragInland: number, //decimal
    readonly InventarPreis: number, //decimal
    readonly Einkaufspreis: number,//decimal
    readonly ProjektRabattSteuerBetrag: number, //decimal
    readonly RabattBetragAssortierung: number, //decimal
    readonly RabattBetragDetail: number, //decimal
    readonly SubVon: number,
    readonly Preiseinheit: number,
    readonly OP: number,
    readonly OPLosGroesse: number, //decimal
    readonly OPTeilmengeZeiteinheit: number,
    readonly OPTeilmengeErwartet: number, //decimal
    readonly OPTeilmengeAbZeit: number, //decimal
    readonly Stueckliste: number,
    readonly StuecklisteArt: number,
    readonly StuecklisteDruckCode: number,
    readonly StuecklistePreisCode: number,
    readonly LeitWaehrung: number,
    readonly Steuersatz: string, //decimal
    readonly SteuerInklusive: boolean,
    readonly BruttoExklusive: string, //decimal
    readonly BruttoSteuer: string, //decimal
    readonly DetailRabattExklusive: number, //decimal
    readonly DetailRabattSteuer: number, //decimal
    readonly DetailRabattInklusive: number, //decimal
    readonly ProjektRabattExklusive: number, //decimal
    readonly ProjektRabattSteuer: number, //decimal
    readonly ProjektRabattInklusive: number, //decimal
    readonly NettoSteuer: string, //decimal
    readonly NettoInklusive: string, //decimal
    readonly DetailRundung: number, //decimal
    readonly LWKurs: number, //decimal
    readonly LWKurseinheit: number,
    readonly LWKursDatum: string,
    readonly LWBruttoExklusive: number, //decimal
    readonly LWBruttoSteuer: number, //decimal
    readonly LWBruttoInklusive: number, //decimal
    readonly LWDetailRabattExklusive: number, //decimal
    readonly LWDetailRabattInklusive: number, //decimal
    readonly LWDetailRabattSteuer: number, //decimal
    readonly LWProjektRabattInklusive: number, //decimal
    readonly LWProjektRabattExklusive: number, //decimal
    readonly LWProjektRabattSteuer: number, //decimal
    readonly LWNettoExklusive: number, //decimal
    readonly LWNettoSteuer: number, //decimal
    readonly LWNettoInklusive: number, //decimal
    readonly LWDurchschnittlEP: number, //decimal
    readonly LWInventarpreis: number, //decimal
    readonly LWLagerpreisdatum: string,
    readonly LagerCode: string,
    readonly LagerWaehrung: number,
    readonly LagerKurs: number, //decimal
    readonly LagerKurseinheit: number,
    readonly LagerKursDatum: string,
    readonly LagerDurchschnittlEP: number, //decimal
    readonly LagerInventarpreis: number, //decimal
    readonly LagerPreisdatum: string,
    readonly StatistikInklusive: number, //decimal
    readonly StatistikExklusive: number, //decimal
    readonly LWStatistikInklusive: number, //decimal
    readonly LWStatistikExklusive: number, //decimal
    readonly Auslieferort: number,
    readonly ArtCode: string,
    readonly ArtBezeichnung: string,
    readonly Sprache: number,
    readonly ProzessartCode: string,
    readonly ProzessArtBezeichnung: string,
    readonly EinheitCode: string,
    readonly WaehrungCode: string,
    readonly RabattCode: string,
    readonly SteuerCode: string,
    readonly SteuerFaktor: number, //decimal
    readonly StammSteuerInklusive: boolean,
    readonly Produkt: number,
    readonly ProduktBezeichnung: string,
    readonly Einzelpreis: string, //decimal
    readonly Sortierung: string,
    readonly Klassifizierung: string,
    readonly ProduktGruppe: string,
    readonly ProduktGesperrt: boolean,
    readonly Bestandesfuehrung: boolean,
    readonly Chargenpflicht: boolean,
    readonly Seriennummernpflicht: boolean,
    readonly Bestand: number, //decimal
    readonly Bestellt: number, //decimal
    readonly Reserviert: number, //decimal
    readonly Lagerfach: string,
    readonly BereitsGebucht: boolean
  ) {}

  static createFromListResponse (responseData: ProjectDetailsResponse[]): ProjectDetail[] {
    return responseData.map((item: ProjectDetailsResponse ) => {
      return new ProjectDetail(
        item.ID,
        item.IDMarker ? item.IDMarker : '',
        item.Vorgang ? item.Vorgang : '',
        item.Projekt,
        item.Zeile,
        item.Art,
        item.Seitenumbruch,
        item.Lagerung ? item.Lagerung : '',
        item.DisplayText ? item.DisplayText : '',
        item.Version ? item.Version : '',
        parseFloat(item.Menge.toString()).toFixed(3).toString(), //decimal
        parseFloat(item.MengeErfasst.toString()).toFixed(3).toString(), //decimal
        item.Einheit,
        parseFloat(item.Preis.toString()).toFixed(2).toString(), //decimal
        item.Waehrung,
        item.Rabatt,
        item.Steuer,
        item.Preisherkunft,
        item.Netto,
        item.Gestaffelt,
        item.Assortiert,
        item.TextArt,
        item.Text ? item.Text : '',
        item.TextRTF ? item.TextRTF : '',
        item.KLText ? item.KLText : '',
        item.KLTextRTF ? item.KLTextRTF : '',
        item.Kommission,
        item.KommissionsNummer ? item.KommissionsNummer : '',
        item.KommissionsBezeichnung ? item.KommissionsBezeichnung : '',
        item.KommissionArtBezeichnung ? item.KommissionArtBezeichnung : '',
        item.Ertrag,
        item.Aufwand,
        item.Kostenstelle,
        item.Kostentraeger,
        item.Debitoren,
        item.Kreditoren,
        item.Gesperrt,
        item.GesperrtVon,
        item.GesperrtVonNameK,
        item.Prozessart,
        item.ReferenzTermin ? item.ReferenzTermin : '',
        item.Summenreferenz ? item.Summenreferenz : '',
        parseFloat(item.BruttoInklusive.toString()).toFixed(2).toString(), //decimal
        parseFloat(item.SteuerBetrag.toString()).toFixed(2).toString(), //decimal
        item.RabattBetrag, //decimal
        item.ProjektRabatt, //decimal
        parseFloat(item.NettoExklusive.toString()).toFixed(2).toString(), //decimal
        item.NettoExklusiveInland, //decimal
        item.SteuerBetragInland, //decimal
        item.InventarPreis, //decimal
        item.Einkaufspreis,//decimal
        item.ProjektRabattSteuerBetrag, //decimal
        item.RabattBetragAssortierung, //decimal
        item.RabattBetragDetail, //decimal
        item.SubVon,
        item.Preiseinheit,
        item.OP,
        item.OPLosGroesse, //decimal
        item.OPTeilmengeZeiteinheit,
        item.OPTeilmengeErwartet, //decimal
        item.OPTeilmengeAbZeit, //decimal
        item.Stueckliste,
        item.StuecklisteArt,
        item.StuecklisteDruckCode,
        item.StuecklistePreisCode,
        item.LeitWaehrung,
        parseFloat(item.Steuersatz.toString()).toFixed(1).toString(), //decimal
        item.SteuerInklusive,
        parseFloat(item.BruttoExklusive.toString()).toFixed(2).toString(), //decimal
        parseFloat(item.BruttoSteuer.toString()).toFixed(2).toString(), //decimal
        item.DetailRabattExklusive, //decimal
        item.DetailRabattSteuer, //decimal
        item.DetailRabattInklusive, //decimal
        item.ProjektRabattExklusive, //decimal
        item.ProjektRabattSteuer, //decimal
        item.ProjektRabattInklusive, //decimal
        parseFloat(item.NettoSteuer.toString()).toFixed(2).toString(), //decimal
        parseFloat(item.NettoInklusive.toString()).toFixed(2).toString(), //decimal
        item.DetailRundung, //decimal
        item.LWKurs, //decimal
        item.LWKurseinheit,
        item.LWKursDatum ? item.LWKursDatum : '',
        item.LWBruttoExklusive, //decimal
        item.LWBruttoSteuer, //decimal
        item.LWBruttoInklusive, //decimal
        item.LWDetailRabattExklusive, //decimal
        item.LWDetailRabattInklusive, //decimal
        item.LWDetailRabattSteuer, //decimal
        item.LWProjektRabattInklusive, //decimal
        item.LWProjektRabattExklusive, //decimal
        item.LWProjektRabattSteuer, //decimal
        item.LWNettoExklusive, //decimal
        item.LWNettoSteuer, //decimal
        item.LWNettoInklusive, //decimal
        item.LWDurchschnittlEP, //decimal
        item.LWInventarpreis, //decimal
        item.LWLagerpreisdatum ? item.LWLagerpreisdatum : '',
        item.LagerCode ? item.LagerCode : '',
        item.LagerWaehrung,
        item.LagerKurs, //decimal
        item.LagerKurseinheit,
        item.LagerKursDatum ? item.LagerKursDatum : '',
        item.LagerDurchschnittlEP, //decimal
        item.LagerInventarpreis, //decimal
        item.LagerPreisdatum ? item.LagerPreisdatum : '',
        item.StatistikInklusive, //decimal
        item.StatistikExklusive, //decimal
        item.LWStatistikInklusive, //decimal
        item.LWStatistikExklusive, //decimal
        item.Auslieferort,
        item.ArtCode ? item.ArtCode : '',
        item.ArtBezeichnung ? item.ArtBezeichnung : '',
        item.Sprache,
        item.ProzessartCode ? item.ProzessartCode : '',
        item.ProzessArtBezeichnung ? item.ProzessArtBezeichnung : '',
        item.EinheitCode ? item.EinheitCode : '',
        item.WaehrungCode ? item.WaehrungCode : '',
        item.RabattCode ? item.RabattCode : '',
        item.SteuerCode ? item.SteuerCode : '',
        item.SteuerFaktor, //decimal
        item.StammSteuerInklusive,
        item.Produkt,
        item.ProduktBezeichnung ? item.ProduktBezeichnung : '',
        parseFloat(item.Einzelpreis.toString()).toFixed(2).toString(), //decimal
        item.Sortierung ? item.Sortierung : '',
        item.Klassifizierung ? item.Klassifizierung : '',
        item.ProduktGruppe ? item.ProduktGruppe : '',
        item.ProduktGesperrt,
        item.Bestandesfuehrung,
        item.Chargenpflicht,
        item.Seriennummernpflicht,
        item.Bestand, //decimal
        item.Bestellt, //decimal
        item.Reserviert, //decimal
        item.Lagerfach ? item.Lagerfach : '',
        item.BereitsGebucht
      )
    })
  }
}
